import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css";

export const systelTheme = responsiveFontSizes(
    createTheme(
        {
            // CONFIGURAZIONE FONT - Moderno e tecnologico
            typography: {
                fontFamily: ['"Inter"', 'system-ui', 'Segoe UI', 'Roboto', 'sans-serif'].join(','),
                h1: { fontWeight: 700, letterSpacing: '-0.02em' },
                button: { letterSpacing: '0.01em' },
            },

            // CONFIGURAZIONE PALETTE - Colori tecnologici ispirati al logo Claire
            palette: {
                mode: 'light',
                primary: { main: '#00BCD4', light: '#4DD0E1', dark: '#0097A7', contrastText: '#FFFFFF' },
                secondary: { main: '#2C5F77', light: '#5A8CA3', dark: '#1E4255', contrastText: '#FFFFFF' },
                success: { main: '#00897B', light: '#4DB6AC', dark: '#00695C', contrastText: '#FFFFFF' },
                info: { main: '#0288D1', light: '#4FC3F7', dark: '#01579B', contrastText: '#FFFFFF' },
                warning: { main: '#FFA726', light: '#FFB74D', dark: '#F57C00', contrastText: '#000000' },
                error: { main: '#e82823', light: '#EF5350', dark: '#C62828', contrastText: '#FFFFFF' },
                background: {
                    default: '#E8F6F8',  // Turchese pallidissimo
                    paper: '#EDF8FA'      // Via di mezzo - più colorato del paper originale, meno del background
                },
                text: { primary: '#1A2732', secondary: '#546E7A', disabled: '#90A4AE' },
                divider: '#B2EBF2',
            },

            // CONFIGURAZIONE FORME - Morbide ma moderne
            shape: {
                borderRadius: 14,
            },

            // CONFIGURAZIONE COMPONENTI
            components: {
                // BUTTON moderno e morbido
                MuiButton: {
                    styleOverrides: {
                        root: { borderRadius: 14, textTransform: 'none', fontWeight: 600 },
                        containedPrimary: {
                            boxShadow: 'none',
                            ':hover': { backgroundColor: '#00ACC1' },
                        },
                        outlined: { borderColor: '#00BCD4', ':hover': { borderColor: '#0097A7', backgroundColor: 'rgba(0, 188, 212, 0.04)' } },
                    },
                },

                // CARD con ombre tecnologiche morbide
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 16,
                            boxShadow: '0 4px 16px rgba(0, 188, 212, 0.15)'
                        }
                    }
                },

                MuiAppBar: {
                    styleOverrides: {
                        colorPrimary: {
                            backgroundColor: '#00BCD4',
                            boxShadow: '0 2px 8px rgba(0, 188, 212, 0.25)'
                        }
                    }
                },

                // TEXTFIELD trasparenti - VERSIONE CORRETTA
                MuiTextField: {
                    styleOverrides: {
                        root: {
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: 'transparent', // ✅ Esplicitamente trasparente
                                borderRadius: 14,
                                "& fieldset": {
                                    borderColor: "rgba(0, 188, 212, 0.3)",
                                },
                                "&:hover fieldset": {
                                    borderColor: "rgba(0, 188, 212, 0.6)",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: "#00BCD4",
                                },
                            },
                        },
                    },
                },

                // CHIP morbidi
                MuiChip: {
                    styleOverrides: {
                        root: {
                            borderRadius: 20,
                        },
                    },
                },
            },

            // COLORI CUSTOM per Claire
            andonStatoPagamento: {
                inLavorazione: "#FFA726", // Amber
                daRichiedere: "#42A5F5", // Light Blue
                inAttesaPagamento: "#FFEB3B", // Yellow
                parzialmentePagato: "#66BB6A", // Light Green
                pagato: "#00897B", // Teal
                annullato: "#78909C", // Blue Grey
            },
            coloriFiltro: {
                attivo: "#B2EBF2", // Cyan 100
                disattivo: '#EDF8FA', // Paper color
            },
        },
        itIT
    )
);